import { b as _defineProperty, _ as _getPrototypeOf, a as _possibleConstructorReturn, c as _inherits, d as _classCallCheck, e as _createClass, Q } from '../_chunks/dep-b05afc19.js';
import { IconBase } from '../icon.js';
import '../util/classname.js';
import '../util/size-props.js';
import '../util/check-url-and-load.js';

var _class;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var element = {
  "attributes": {
    "fill": "none",
    "viewBox": "0 0 24 24",
    "width": "1em",
    "height": "1em"
  },
  "nodeName": "svg",
  "children": [{
    "attributes": {
      "id": "round"
    },
    "nodeName": "g",
    "children": [{
      "attributes": {
        "id": "fill1",
        "cx": 12,
        "cy": 12,
        "r": 7,
        "fill": "transparent"
      },
      "nodeName": "circle",
      "children": []
    }, {
      "attributes": {
        "id": "stroke1",
        "cx": 12,
        "cy": 12,
        "r": 7,
        "stroke": "currentColor",
        "stroke-linecap": "square",
        "stroke-width": 2
      },
      "nodeName": "circle",
      "children": []
    }]
  }]
};
var RoundIcon = (_class = /*#__PURE__*/function (_IconBase) {
  _inherits(RoundIcon, _IconBase);
  var _super = _createSuper(RoundIcon);
  function RoundIcon() {
    var _this;
    _classCallCheck(this, RoundIcon);
    _this = _super.call(this);
    _this.props = _objectSpread(_objectSpread({}, _this.props), {}, {
      id: "round"
    });
    return _this;
  }
  return _createClass(RoundIcon);
}(IconBase), _defineProperty(_class, "icon", element), _class);
RoundIcon = __decorateClass([Q("t-icon-round")], RoundIcon);

export default RoundIcon;
//# sourceMappingURL=round.js.map
